function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// https://bitbucket.org/atlassian/atlaskit/src/099b332e213214afb6a56a029fca1eb279d60cce/packages/layer-manager/src/components/ScrollLock.js?at=master&fileviewer=file-view-default
// https://github.com/jossmac/react-scrolllock/
//
import ExecutionEnvironment from 'exenv';
import React from 'react';
import { getMobileDevice } from './getEnvironmentConstants';

var applyScrollLock = function applyScrollLock() {};

var removeScrollLock = function removeScrollLock() {};

if (ExecutionEnvironment.canUseDOM) {
  var target = document.body;
  var scrollLocksActive = 0;
  var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
  var originalStyles = {};
  var originalScroll = {
    top: 0,
    left: 0
  };
  STYLE_KEYS.forEach(function (key) {
    return originalStyles[key] = target.style[key];
  });
  var MOBILE_IOS_STYLE_KEYS = ['top'];
  var originalIOSStyles = {};
  MOBILE_IOS_STYLE_KEYS.forEach(function (key) {
    return originalIOSStyles[key] = target.style[key];
  });
  var OS = getMobileDevice();

  var getScrollBarPadding = function getScrollBarPadding() {
    return window.innerWidth - document.body.clientWidth;
  };

  var getOriginalRightPadding = function getOriginalRightPadding() {
    return parseInt(originalStyles.paddingRight, 10) || 0;
  };

  var restoreScroll = function restoreScroll() {
    requestAnimationFrame(function () {
      return window.scrollTo(originalScroll.left, originalScroll.top);
    });
  };

  var saveScroll = function saveScroll() {
    originalScroll.top = window.scrollY;
    originalScroll.left = window.scrollX;
  };

  var resetStyling = function resetStyling() {
    STYLE_KEYS.forEach(function (rule) {
      return target.style[rule] = originalStyles[rule];
    }); // We need to reset any custom styles that were applied for mobile iOS specific instances in `setLockStyling`

    if (isMobileiOS()) {
      MOBILE_IOS_STYLE_KEYS.forEach(function (rule) {
        return target.style[rule] = originalIOSStyles[rule];
      });
    }
  }; // Determines whether we're on iOS or not; because of
  // iOS's WebView implementation, scrolling still
  // occurs even if overflow: hidden is set, so
  // we need to do some extra work to prevent the
  // body from scrolling while the scroll lock is
  // enabled.


  var isMobileiOS = function isMobileiOS() {
    return OS === 'iOS';
  };

  var setLockStyling = function setLockStyling() {
    var LOCK_STYLES = {
      // account for possible `width: 100%;` declaration on body
      boxSizing: 'border-box',
      height: '100vh',
      // For most applications, this overflow handles
      // the body scroll locking without any issue.
      // However, iOS is the main exception, and that's
      // handled below with `position`
      overflow: 'hidden',
      // For iOS, the only way to reliably lock
      // the body from scrolling (without messing
      // with event handlers that prevent touchmove)
      // is to set the body to position fixed.
      // Separately, we also need to
      position: isMobileiOS() ? 'fixed' : 'auto'
    }; // If we're on iOS, we're setting the body to fixed
    // positioning, which means that the scroll position
    // of the page is lost—to maintain your place on the
    // page while the modal is visible, we set the newly
    // fixed body element with its top set to the scroll
    // position that was set before scroll lock was enabled
    // See https://stackoverflow.com/a/20231481/652765

    if (isMobileiOS()) {
      LOCK_STYLES.top = "-".concat(originalScroll.top, "px");
    }

    Object.keys(LOCK_STYLES).forEach(function (rule) {
      return target.style[rule] = LOCK_STYLES[rule];
    });
  };

  applyScrollLock = function applyScrollLock(_ref) {
    var shouldGetScrollBarPadding = _ref.shouldGetScrollBarPadding;

    // apply the target padding if this is the first scroll lock applied
    if (scrollLocksActive < 1) {
      // Accounts for padding due to scrollbar width disappearing
      var newPaddingRight;

      if (shouldGetScrollBarPadding) {
        newPaddingRight = getScrollBarPadding() + getOriginalRightPadding();
      } // For iOS, we need to account for scroll position
      // and save/restore it as scroll lock is enabled/disabled
      // since position: fixed reset the scroll position.


      if (isMobileiOS()) {
        saveScroll();
      }

      setLockStyling();

      if (shouldGetScrollBarPadding) {
        if (newPaddingRight && !Number.isNaN(newPaddingRight)) {
          target.style.paddingRight = "".concat(newPaddingRight, "px");
        }
      }
    }

    scrollLocksActive += 1;
  };

  removeScrollLock = function removeScrollLock() {
    scrollLocksActive = Math.max(scrollLocksActive - 1, 0);

    if (scrollLocksActive < 1) {
      requestAnimationFrame(function () {
        return resetStyling();
      }); // Restore the scroll on iOS since we're
      // doing position: fixed, which resets
      // the scroll position.

      if (isMobileiOS()) {
        restoreScroll();
      }
    }
  };
}

var ScrollLock = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ScrollLock, _React$PureComponent);

  var _super = _createSuper(ScrollLock);

  function ScrollLock() {
    _classCallCheck(this, ScrollLock);

    return _super.apply(this, arguments);
  }

  _createClass(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/prop-types
      var shouldGetScrollBarPadding = this.props.shouldGetScrollBarPadding;
      applyScrollLock({
        shouldGetScrollBarPadding: shouldGetScrollBarPadding
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeScrollLock();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(React.PureComponent);

_defineProperty(ScrollLock, "defaultProps", {
  shouldGetScrollBarPadding: false
});

export default ScrollLock;